import TecnaVueShared, { Pagination } from "tecna-vue-shared/src/main"
import Vue from "vue"

Vue.use(TecnaVueShared)


export default TecnaVueShared

export { Pagination }